<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <AppointmentRow
          v-for="seating in current_seminar.Seatings"
          :key="seating.SeatingID"
          :seminar_object="current_seminar"
          :seating_object="seating"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AppointmentRow from "@/components/CustomRowComponents/AppointmentRow.vue";

export default {
  name: "AppointmentContainer",
  props: {
    seminar_object: { type: Object }
  },
  components: {
    AppointmentRow
  },
  data() {
    return {
      current_seminar: this.seminar_object
    };
  },
  computed: {}
};
</script>

<style lang="scss" scoped></style>
